import React from 'react'
import ContactForm from 'components/Forms/ContactForm'
import parser from 'html-react-parser'
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image'

export default function ConnectForm2({data}) {
    const {connectForm2Subtitle, connectForm2Title, connectForm2Image} = data
    return (
        <div className='image-radius-wrap connect-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-5'>
                        <div className='image-radius-patrn-1 white-circle-ptrn-col'>
                            <GatsbyImage image={getImage(connectForm2Image?.localFile)} alt='image' />
                        </div>
                    </div>
                    <div className='col-md-7'>
                        <div className='connect-form-sec radio-check-label-sec'>
                            <div className='contactfrm-head'>
                                <div className='heading-level-2 blue-color mb-3'>
                                    {connectForm2Title && parser(connectForm2Title)}
                                </div>
                                <p>
                                    {connectForm2Subtitle && parser(connectForm2Subtitle)}
                                </p>
                            </div>
                            <ContactForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
